import React from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'

import { userMenu } from './MenuItems'
import MenuNode from './MenuNode'

import './SideMenu.sass'

const SideMenu = (props) => {

	const { toggleSidenav, open, user, company } = props
	const userRole = user.roles[0]

	let menuItems = userMenu.menu;
	if (userRole === 'custom_partner') {
		menuItems = [];
		const user_permissions = user.permissions || [];
		if (_.find(user_permissions, { 'perm_category_id': 4, 'a_view': true })) menuItems.push(userMenu.menu[0]);
		if (_.find(user_permissions, { 'perm_category_id': 13, 'a_view': true })) menuItems.push(userMenu.menu[1]);
	}

	if (!user) {
		return <div>Loading...</div>
	}

	return (
		<nav className={`sideMenu ${open ? '' : 'sideMenuMin'}`} aria-label="primary navigation">
			<div className="header-logo-container">
				<Link to="/" className="header-logo" id="rosco-header-logo" />
			</div>
			<div className="expand-wrapper">
				<svg width="32" height="32" viewBox="0 0 24 24" focusable="false" role="presentation" onClick={toggleSidenav}>
					<path d="M10.294 9.698a.988.988 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .988.988 0 0 1 0-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fillRule="evenodd" />
				</svg>
			</div>

			<div className="sideMenu-nav">
				<ul className="sideMenu-list">
					{menuItems.map((menuItem, index) =>
						<MenuNode
							linkIndex={index === 0}
							linkTo={menuItem.linkTo}
							key={menuItem.linkTitle}
							linkTitle={menuItem.linkTitle}
							itemIcon={menuItem.itemIcon}
							open={open}
						/>
					)}
				</ul>
			</div>
		</nav>
	)
}

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company,
		whitelabel: state.user.whitelabel,
		isDevicesHaveProblems: state.assets.isDevicesHaveProblems,
		lastViewedVehiclesPage: state.assets.lastViewedVehiclesPage
	}),
)(SideMenu);
